<template>
  <a-modal
    v-model:open="_open"
    width="500px"
    height="380px"
    title=""
    class="protocolConfirm"
    :ok-text="$t('que-ren-bing-tong-yi')"
    @ok="$emit('confirm')"
  >
    <div>
      {{ $t('wo-yi-yue-du-bing-tong-yi') }}
      <ALink
        :href="
          !isChinese()
            ? 'https://protocol.rendora.ai/legal/user'
            : 'https://frontend-protocol.xmov.ai/youyan-v3/user'
        "
        name="user"
      >
        {{ $t('mo-fa-you-yan-yong-hu-xie-yi') }}
      </ALink>

      {{ $t('he') }}
      <ALink
        :href="
          !isChinese()
            ? 'https://protocol.rendora.ai/legal/privacy-policy'
            : 'https://frontend-protocol.xmov.ai/youyan-v3/privacy'
        "
        name="policy"
      >
        {{ $t('mo-fa-you-yan-yin-si-zheng-ce') }}
      </ALink>
    </div>
  </a-modal>
</template>
<script lang="ts" setup>
const { $t } = useNuxtApp()

const props = defineProps({
  open: {
    type: Boolean,
  },
})

const emit = defineEmits(['update:open', 'confirm'])

const _open = useVModel(props, 'open', emit)
</script>
<style lang="scss">
.protocolConfirm.ant-modal {
  .ant-modal-content {
    height: 100%;
    display: flex;
    flex-direction: column;
  }

  .ant-modal-body {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .ant-modal-footer {
    text-align: center;
  }
}
</style>
